"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactstrap = require("reactstrap");

var _config = _interopRequireDefault(require("@dom/config"));

var GoogleLogin =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(GoogleLogin, _Component);

  function GoogleLogin() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, GoogleLogin);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(GoogleLogin)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      isSdkLoaded: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "signIn",
    /*#__PURE__*/
    (0, _asyncToGenerator2["default"])(
    /*#__PURE__*/
    _regenerator["default"].mark(function _callee() {
      var response;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return window.gapi.auth2.getAuthInstance().signIn();

            case 3:
              response = _context.sent;

              _this.props.submit(_this.makeApiData(response));

              _context.next = 10;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7]]);
    })));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "makeApiData", function (response) {
      return {
        email: response.w3.U3,
        accessToken: response.Zi.id_token,
        provider: 'google'
      };
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "loadGoogleSdk", function () {
      (function (d, s, id, cb) {
        var element = d.getElementsByTagName(s)[0];
        var fjs = element;
        var js = element;
        js = d.createElement(s);
        js.id = id;
        js.src = '//apis.google.com/js/client:platform.js';
        fjs.parentNode.insertBefore(js, fjs);
        js.onload = cb;
      })(document, 'script', 'google-login', function () {
        var params = {
          client_id: _config["default"].google
        }; // initializing google api -- gapi

        window.gapi.load('auth2', function () {
          if (!window.gapi.auth2.getAuthInstance()) {
            window.gapi.auth2.init(params);

            _this.setState({
              isSdkLoaded: true
            });
          }
        });
      });
    });
    return _this;
  }

  (0, _createClass2["default"])(GoogleLogin, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_reactstrap.Button, {
        color: "google",
        className: this.props.loading ? 'btn-login btn-loading btn-social' : 'btn-social',
        onClick: this.signIn,
        disabled: !this.state.isSdkLoaded
      }, this.props.buttonText);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var isGoogleSdkLoaded = !!document.getElementById('google-login');

      if (isGoogleSdkLoaded) {
        this.setState({
          isSdkLoaded: true
        });
        return;
      }

      this.loadGoogleSdk();
    }
  }]);
  return GoogleLogin;
}(_react.Component);

exports["default"] = GoogleLogin;
(0, _defineProperty2["default"])(GoogleLogin, "defaultProps", {
  buttonText: 'Sign up with Google'
});